import React from 'react';
import paypal from '../assets/icons/Paypal.svg';
import mc from '../assets/icons/mastercard.svg';
import visa from '../assets/icons/visa.svg';
import ae from '../assets/icons/amex.png';
import li from '../assets/icons/linkedin.svg';
import fb from '../assets/icons/facebook.svg';
import recycling from '../assets/icons/Recycling.png';
const Footer = () => {
  return (
    <footer>
      <div className='container-xxl px-3 px-lg-5 px-xxl-0  '>
        <div className='row gx-0 gy-0 gy-md-0  gx-md-0 mx-0 '>
          <div className='col-12 col-md-12 col-xl-9  d-md-block justify-content-center'>
            <div className='row   pb-0 pb-md-2 pb-lg-5 mt-0 mt-md-3 '>
              <div className='col-12 col-md-3 col-xl-3'>
                <h3>SERVICE HOTLINE</h3>
                <p>Kostenlose Hotline</p>
                <p className='num'>0 800 501 56 37</p>
                <p className='' style={{ fontSize: 12 }}>
                  <span style={{ color: 'black' }}>Mo-Do&nbsp;</span>
                  08:00 – 16:45 Uhr
                </p>
                <p className='' style={{ fontSize: 12 }}>
                  {' '}
                  <span className='me-3' style={{ color: 'black' }}>
                    Fr {' '}
                  </span>
                  08:00 – 15:00 Uhr
                </p>
              </div>
              <div className='col-12 col-md-2 col-xl-3  '>
                <h3>HILFE</h3>
                <ul>
                  <li>
                    <a href='#'>Kontakt</a>
                  </li>
                  <li>
                    <a href='#'>Hilfe &amp; FAQ</a>
                  </li>
                </ul>
              </div>
              <div className='col-12 col-md-4 col-xl-3' style={{ justifySelf: 'center' }}>
                <h3>INFORMATIONEN</h3>
                <ul>
                  <li>
                    <a href='#'>Über Uns</a>
                  </li>
                  <li>
                    <a href='#'>Veranstaltungen </a>
                  </li>
                  <li>
                    <a href='#'>Karriere</a>
                  </li>
                  <li>
                    <a href='#'>News</a>
                  </li>
                </ul>
              </div>
              <div className='col-12 col-md-3 col-xl-3 '>
                <h3>RECHTLICHES </h3>
                <ul>
                  <li>
                    <a href='#'>Impressum</a>
                  </li>
                  <li>
                    <a href='#'>Datenschutz</a>
                  </li>
                  <li>
                    <a href='#'>AGB</a>
                  </li>
                </ul>
              </div>
            </div>
            <a
              href='https://www.thembdev.com/'
              className='d-flex py-2 align-items-center '
              style={{ fontSize: 12, opacity: 1 }}>
              Developed By{' '}
              <img
                src='https://mbdev-utils.s3.eu-west-3.amazonaws.com/mbdev_logo_sm.svg'
                alt='mbdev_logo'
                className='ms-2'
              />
            </a>
          </div>

          <div className='col-12 col-md-12 col-xl-3 payment-methods my-0 py-0'>
            <div className='paypal'>
              <img src={paypal} alt='paypal' />
            </div>
            <div className='mc'>
              <img src={mc} alt='paypal' />
            </div>
            <div className='visa'>
              <img src={visa} alt='paypal' />
            </div>
            <div className='ae'>
              <img src={ae} alt='paypal' />
            </div>
            <div className='social d-flex'>
              <img src={li} alt='paypal' />
              <img src={fb} alt='paypal' />
            </div>
            <div className='recycling my-0 py-0'>
              <img src={recycling} alt='paypal' />
            </div>
          </div>

          {/* <div class="col-12 col-md-6 col-lg-4">
        <div class="row gx-5 gy-5"> */}
        </div>
      </div>
      <div className='footer-end py-2'>
        <p className='p-0 m-0'>Alle Rechte liegen bei Standard Systeme GmbH.</p>
      </div>
    </footer>
  );
};

export default Footer;
